import { render } from "./historico.vue?vue&type=template&id=15b771d4&scoped=true"
import script from "./historico.vue?vue&type=script&lang=js"
export * from "./historico.vue?vue&type=script&lang=js"

import "./historico.vue?vue&type=style&index=0&id=15b771d4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15b771d4"]])

export default __exports__